export const toCSS = (value: any) => {
  if (!!Number(value) || Number(value) === 0) {
    return `${value}px`;
  }
  return value;
};

export const convertToCSSValue = (value: any) => {
  if (!!Number(value) || Number(value) === 0) {
    return `${value}px`;
  }
  return value;
};

export const jsonToCSS = (json: any) => {
  let str = '';
  Object.keys(json).map((key) => {
    str += `${key}:${json[key]};`;
  });
  return str;
};
